import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideDashboardWidget } from '@brightnav/dashboard';
import { HttpActionApiService } from './http/http-action-api.service';
import { OpenActionsWidgetComponent } from './widget/open-actions-widget.component';

/** Registers My Open Actions on the Home dashboard. */
export function provideOpenActions(): EnvironmentProviders {
  return makeEnvironmentProviders([
    HttpActionApiService,
    provideDashboardWidget({
      id: 'openActions',
      order: 20,
      component: OpenActionsWidgetComponent,
    }),
  ]);
}
